import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_URL } from "../constants/api";
import { toast } from "react-toastify";

const SignInLayer = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [alertVisible, setAlertVisible] = useState(false);
  const [alert, setAlert] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("pfp-token");
  const [passwordType, setPasswordType] = useState("password")

  useEffect(() => {
    if (token) {
      console.log(localStorage.getItem("group_id")+ "Hi")

      if(localStorage.getItem("group_id") === "3"){
        navigate("/all-recipe-reviews");
      }else{
        navigate("/");
      }
   
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("handle submit");
    const values = {
      email,
      password,
    };

    try {
        const loading = toast.loading("Signing in...")
      const response = await fetch(`${API_URL}/api/backend/auth/login`, {
        method: "POST",
        body: JSON.stringify(values),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const json = await response.json();

      if (response.ok) {
        localStorage.setItem("pfp-token", json.token);
        localStorage.setItem("group_id", json.data.admin_user_group_id);
        toast.dismiss(loading);
        toast.success("Signed in successfully!");
        if (json.data.admin_user_group_id === 3) {
          navigate("/all-recipe-reviews");
        } else {
          navigate("/");
        }
      } else {
        toast.dismiss(loading);
        toast.error("Incorrect email or password!");
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const changeInputType = () => {
    if (passwordType === "password") {
      setPasswordType("text")
      console.log(passwordType)
    } else {
      setPasswordType("password")
      console.log(passwordType)
    }
  }
  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="/assets/images/auth/auth-img.png" alt="" />
        </div>
      </div>

      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="/assets/images/newPfpLogoNewHeader.svg" alt="" />
            </Link>
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                required
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field" >
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={passwordType}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                />
              </div>
              <span
                className={`toggle-password ${passwordType === "text" ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                onClick={changeInputType}
              />
            </div>
            {/* <div className="">
              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-center">
                  <input
                    className="form-check-input border border-neutral-300"
                    type="checkbox"
                    defaultValue=""
                    id="remeber"
                  />
                  <label className="form-check-label" htmlFor="remeber">
                    Remember me{" "}
                  </label>
                </div>
                <Link to="#" className="text-primary-600 fw-medium">
                  Forgot Password?
                </Link>
              </div>
            </div> */}
            <button
              type="submit"
              className="btn btn-primary-600 text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
            >
              {" "}
              Sign In
            </button>
            {/* <div className="mt-32 center-border-horizontal text-center">
              <span className="bg-base z-1 px-4">Or sign in with</span>
            </div>
            <div className="mt-32 d-flex align-items-center gap-3">
              <button
                type="button"
                className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
              >
                <Icon
                  icon="ic:baseline-facebook"
                  className="text-primary-600 text-xl line-height-1"
                />
                Google
              </button>
              <button
                type="button"
                className="fw-semibold text-primary-light py-16 px-24 w-50 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
              >
                <Icon
                  icon="logos:google-icon"
                  className="text-primary-600 text-xl line-height-1"
                />
                Google
              </button>
            </div>
            <div className="mt-32 text-center text-sm">
              <p className="mb-0">
                Don’t have an account?{" "}
                <Link to="/sign-up" className="text-primary-600 fw-semibold">
                  Sign Up
                </Link>
              </p>
            </div> */}
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
